'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function getValue(value) {
	if (typeof value === 'function') {
		return value();
	}
	return value;
}

var QueryResult = (function () {
	_createClass(QueryResult, null, [{
		key: 'withValue',
		value: function withValue(value) {
			return new QueryResult(true, value);
		}
	}, {
		key: 'withError',
		value: function withError(error) {
			return new QueryResult(true, null, error);
		}
	}]);

	function QueryResult() {
		var complete = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
		var value = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
		var error = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

		_classCallCheck(this, QueryResult);

		this.isComplete = complete;
		this.value = value;
		this.error = error;
	}

	_createClass(QueryResult, [{
		key: 'get',
		value: function get() {
			var path = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
			var defaultValue = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

			if (typeof path !== 'string' || path === '') {
				return getValue(defaultValue) || this.value;
			}

			var result = path.split('.').reduce(function (acc, next) {
				return acc ? acc[next] : null;
			}, this.value);

			if (!result) {
				return getValue(defaultValue);
			}

			return result;
		}
	}, {
		key: 'isPending',
		get: function get() {
			return !this.isComplete;
		}
	}, {
		key: 'didFail',
		get: function get() {
			return this.isComplete && this.error !== null;
		}
	}, {
		key: 'didSucceed',
		get: function get() {
			return this.isComplete && this.error === null;
		}
	}]);

	return QueryResult;
})();

exports['default'] = QueryResult;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-reactor/dist/result.js
// module id = z57U
// module chunks = 15